import React from "react";
import { Link } from "react-router-dom";
import "../footer.css";
import { ImWhatsapp } from "react-icons/im";
import { FiInstagram, FiMapPin } from "react-icons/fi";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-inner">

        {/* BLOQUE SUPERIOR */}
        <div className="footer-top">

          {/* CONTACTO */}
          <div className="footer-col">
            <h4>Contacto</h4>

            <a href="https://wa.link/45a22m" target="_blank" rel="noreferrer" className="footer-link">
              <ImWhatsapp /> +54 11 2818-1122
            </a>

            <a href="https://instagram.com/liftingstore.arg/" target="_blank" rel="noreferrer" className="footer-link">
              <FiInstagram /> @liftingstore.arg
            </a>

            <div className="footer-link">
              <FiMapPin /> Buenos Aires, Argentina
            </div>
          </div>

          {/* POLITICAS */}
          <div className="footer-col">
            <h4>Información</h4>
            <Link to="/politicas" className="footer-link">Cómo hacer un pedido</Link>
            <Link to="/politicas" className="footer-link">Medios de pago</Link>
            <Link to="/politicas" className="footer-link">Envíos</Link>
            <Link to="/politicas" className="footer-link">Soporte</Link>
          </div>

          {/* NAVEGACION */}
          <div className="footer-col">
            <h4>Categorías</h4>
            <Link to="/rodilleras" className="footer-link">Rodilleras</Link>
            <Link to="/rodilleras-rig" className="footer-link">Rodilleras Rígidas</Link>
            <Link to="/cinturones" className="footer-link">Cinturones</Link>
            <Link to="/calzado" className="footer-link">Calzado</Link>
            <Link to="/muñequeras" className="footer-link">Muñequeras</Link>
            <Link to="/singlets" className="footer-link">Singlets</Link>
          </div>

        </div>

        {/* LINEA DIVISORIA */}
        <div className="footer-divider" />

        {/* MARCAS */}
        <div className="footer-brands">
          <h4>Marcas</h4>
          <div className="footer-logos">
            <img src="/Logos/sbd-logo.png" alt="SBD" />
            <img src="/Logos/inzer-logo.png" alt="Inzer" />
            <img src="/Logos/a7-logo.webp" alt="A7" />
            <img src="/Logos/stoic-logo.png" alt="Stoic" />
            <img src="/Logos/pioneer-logo.png" alt="Pioneer" />
          </div>
        </div>  

        {/* COPYRIGHT */}
        <div className="footer-bottom">
          <div className="footer-copy">
            © {new Date().getFullYear()} Lifting Store — Todos los derechos reservados.
          </div>

          <div className="footer-dev">
            Desarrollo web & Estrategia digital por{" "}
            <a
              href="https://www.instagram.com/digitalworldpalermo/ "
              target="_blank"
              rel="noreferrer"
            >
              Martín Sánchez Borda
            </a>
          </div>
        </div>


      </div>
    </footer>
  );
};

export default Footer;
